import type { GridOptions } from "ag-grid-community";
import { type ComponentPropsWithoutRef, forwardRef, type Ref } from "react";

import { AgGridReact, blisQuartzTheme } from "@/components/grid/AgGrid";
import { cn } from "@/components/ui/utils";

type AdminGridProps = ComponentPropsWithoutRef<typeof AgGridReact> & {
  className?: string;
};

function AdminGrid(
  { className, ...props }: AdminGridProps,
  ref: React.Ref<AgGridReact>,
) {
  return (
    <div
      className={cn("ag-theme-quartz ag-theme-blis flex-1 min-h-0", className)}
    >
      <AgGridReact {...props} ref={ref} />
    </div>
  );
}

export const denseAdminGridTheme = blisQuartzTheme.withParams({
  rowHeight: 32,
  headerHeight: 32,
  menuBackgroundColor: "var(--background)",
  headerBackgroundColor: "var(--background)",
  headerTextColor: "var(--muted-foreground)",
  fontFamily: "var(--font-sans)",
  wrapperBorderRadius: 0,
  wrapperBorder: { width: 0 },
});

const _AdminGrid = forwardRef(AdminGrid) as <T = unknown>(
  props: GridOptions<T> & { className?: string; ref?: Ref<AgGridReact<T>> },
) => React.ReactElement;

export { _AdminGrid as AdminGrid };
